module.exports = __webpack_public_path__ + "static/img/shiming.92cf6aa6.jpg";